var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSocial(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M19.7 23.5H4.3c-2.1 0-3.8-1.7-3.8-3.8V4.3C.5 2.2 2.2.5 4.3.5h15.3c2.1 0 3.8 1.7 3.8 3.8v15.3c.1 2.2-1.6 3.9-3.7 3.9zM4.3 1.5c-1.6 0-2.8 1.3-2.8 2.8v15.3c0 1.6 1.3 2.8 2.8 2.8h15.3c1.6 0 2.8-1.3 2.8-2.8V4.3c0-1.6-1.3-2.8-2.8-2.8z",
    fill: "#dbd4ce",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9 15.8h-3.8c-.2 0-.3-.1-.4-.2l-1.9-3.3c-.1-.2-.1-.3 0-.5l1.9-3.3c.1-.2.3-.2.4-.2h3.8c.2 0 .3.1.4.2l1.9 3.3c.1.2.1.3 0 .5l-1.9 3.3c-.1.1-.2.2-.4.2zm-3.5-1h3.2l1.6-2.8-1.6-2.8h-3.2L8.8 12z",
    fill: "#dbd4ce",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.7 9.2h-4.9c-.3 0-.5-.2-.5-.5s.2-.5.5-.5h4.9c.3 0 .5.2.5.5s-.2.5-.5.5zM10.2 15.8H5.3c-.3 0-.5-.2-.5-.5s.2-.5.5-.5h4.9c.3 0 .5.2.5.5s-.3.5-.5.5zM10.1 9.3c-.1 0-.2 0-.2-.1-.3-.1-.4-.4-.2-.7l2.4-4.2c.1-.2.4-.3.7-.2s.3.4.2.7L10.5 9c-.1.2-.2.3-.4.3zM11.5 19.9c-.1 0-.2 0-.2-.1-.2-.1-.3-.4-.2-.7l2.4-4.2c.1-.2.4-.3.7-.2.2.1.3.4.2.7L12 19.6c-.2.2-.4.3-.5.3zM8.3 12.5c-.2 0-.3-.1-.4-.2L5.4 8.1c-.1-.3-.1-.6.2-.7.2-.1.5-.1.7.2l2.4 4.2c.1.2.1.5-.2.7h-.2zM18.2 16.7c-.2 0-.3-.1-.4-.2l-2.4-4.2c-.1-.2-.1-.5.2-.7.2-.1.5-.1.7.2l2.4 4.2c.1.2.1.5-.2.7h-.3z",
    fill: "#dbd4ce",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 20.2c-4.5 0-8.2-3.7-8.2-8.2S7.5 3.8 12 3.8s8.2 3.7 8.2 8.2-3.7 8.2-8.2 8.2zm0-15.4C8 4.8 4.8 8 4.8 12S8 19.2 12 19.2s7.2-3.2 7.2-7.2S16 4.8 12 4.8z",
    fill: "#dbd4ce",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocial);
export default __webpack_public_path__ + "static/media/social.a9ab6a3883c973c7235777f55538b42f.svg";
export { ForwardRef as ReactComponent };